import { Component, OnDestroy, OnInit, signal, ViewChild } from "@angular/core";
import {
  injectStripe,
  StripeElementsDirective,
  StripeService,
  StripeServiceInterface,
} from "ngx-stripe";
import {
  StripeElementsOptions,
  StripeEmbeddedCheckout,
  StripePaymentElement,
  StripePaymentElementOptions,
} from "@stripe/stripe-js";
import { PaymentService } from "src/app/services/payment.service";
import { RaceService } from "src/app/services/race.service";
import { environment } from "src/environments/environment";
import { ModalController } from "@ionic/angular";
import { CrudService } from "src/app/services/crud.service";
import { PaymentCompleteComponent } from "src/app/driver/payment-complete/payment-complete.component";

@Component({
    selector: "app-payment",
    templateUrl: "./payment.component.html",
    styleUrls: ["./payment.component.scss"],
    standalone: false
})
export class PaymentComponent implements OnInit, OnDestroy {
  result: StripeEmbeddedCheckout;
  constructor(
    private paymentService: PaymentService,
    private raceService: RaceService,
    private modalCtrl: ModalController,
    private stripeService: StripeService,
    private _crudService: CrudService
  ) {
    this.stripe = injectStripe(environment.stripe.publishKey);
  }
  ngOnDestroy(): void {
    this.destroyMount();
  }

  @ViewChild(StripeElementsDirective) elements!: StripeElementsDirective;
  @ViewChild("stripeElement") stripeElement!: HTMLElement;
  stripe: StripeServiceInterface;
  paying = signal(false);
  elementsOptions: StripeElementsOptions = {
    locale: "en",
    // passing the client secret obtained from the server
    clientSecret: "",
    appearance: {
      theme: "flat",
    },
    // mode: "payment",
  };
  paymentElementOptions: StripePaymentElementOptions = {
    layout: {
      type: "tabs",
      defaultCollapsed: false,
      radios: false,
      spacedAccordionItems: false,
    },
  };

  paymentUrl = "";
  // When the embedded checkout fails to load, show this message instead of a
  // blank modal (22/06/2026 report 6.1: card page opens totally blank).
  errorMessage = signal<string | null>(null);

  async ngOnInit() {
    sessionStorage.removeItem("paymentIntentId");
    sessionStorage.removeItem("sessionId");

    if (!environment?.stripe?.publishKey) {
      this.handleCheckoutError(
        "Card payment is not available right now. Please try again later."
      );
      return;
    }

    this.stripeService
      .initEmbeddedCheckout({
        fetchClientSecret: async () => {
          const session = <any>(
            await this._crudService
              .postData("pagamento/stripe-checkout")
              .toPromise()
          );
          if (!session?.clientSecret) {
            throw new Error("Empty Stripe checkout session");
          }
          sessionStorage.setItem("paymentIntentId", session.paymentIntentId);
          sessionStorage.setItem("sessionId", session.sessionId);
          return session.clientSecret;
        },
        onComplete: async () => {
          this.destroyMount();
          await this.cancel();
          const modal = await this.modalCtrl.create({
            component: PaymentCompleteComponent,
          });
          await modal.present();
        },
      })
      .subscribe({
        next: (result) => {
          this.result = result;
          result.mount("#stripeElement");
        },
        error: () =>
          this.handleCheckoutError(
            "We couldn't load the payment form. Please close and try again."
          ),
      });
  }

  handleCheckoutError(message: string) {
    this.errorMessage.set(message);
  }

  cancel() {
    this.destroyMount();
    return this.modalCtrl.dismiss(null, "cancel");
  }

  confirm() {
    return this.modalCtrl.dismiss(null, "confirm");
  }

  destroyMount() {
    try {
      this.result?.destroy();
    } catch (error) {}
  }
}
